module.exports = __webpack_public_path__ + "img/vegetable-snap-peas-350x184.7fc946f9.jpg";